/***** Begin bsAgentsNearYou Scripts *****/
var agentCount = 0;
var bsAgentsNearYou = {

    defaultUserLocation: "",
    SCPageName: "",
    emailAgentIconText: "",
    visitAgentIconText: "",
    getDirectionsLinkText: "",
    callAgentLinkText: "",
    agentFacebookText: "",
    agentTwitterText: "",

    init: function (carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding) {
        if (!isCustomer) {
            bsAgentsNearYou.parseAgentList(bsCommon.retrieveAgents(), carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding);
            bsAgentsNearYou.subscribeToEvents(carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding);

        }else{
            bsAgentsNearYou.setUpPagination(carouselId, panelsToDisplay, isCustomer);
            setTimeout(function () { bsAgentsNearYou.checkAgentImages(carouselId) }, 1000);
        }

    },

    subscribeToEvents: function (carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding) {
        globalEvents.Event('agentListUpdated').subscribe(function (result) {
            if ($('#' + carouselId + ' .loaded').length == 0) {
                bsAgentsNearYou.parseAgentList(result, carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding);
                $('#' + carouselId + ' .loading').addClass('inited').removeClass('loading');
            }
        });
        globalEvents.Event('agentListCleared').subscribe(function (carouselId) { bsAgentsNearYou.clearAgentList(carouselId);});
    },

    setUserLocation: function () {
        if (bsAgentsNearYou.defaultUserLocation === "") {
            bsAgentsNearYou.defaultUserLocation = $(".bsAgentsNearYou .headerTitle").html();
        }

        if ((bsCommon.userLocationJson() != null) && (bsCommon.userLocationJson() != "") && (bsCommon.userLocationJson().PostalCode != "")) {
            $(".bsAgentsNearYou .headerTitle").html(bsAgentsNearYou.defaultUserLocation + bsCommon.userLocationJson().PostalCode);
        }
    },

    clearAgentList: function (carouselId) {
        if(carouselId === undefined)
        {
            $('.bsAgentsNearYou .bsANYListing .carousel-inner').html("<li><div class='agentsFindMessage'>No Agents Found.</div></li>");
        }else{
            $('#' + carouselId + ' .carousel-inner').html("<li><div class='agentsFindMessage'>No Agents Found.</div></li>");
        }
    },

    parseAgentList: function (agentList, carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding) {
        if (agentList !== null) {
            try {
                var agents = JSON.parse(agentList);
                agentCount = agents.Agents.length;
                if ((agents.Agents !== null) && (agents.Agents !== "null") && (agents.Agents.length > 0)) {
                    if (agents.Agents.length < agentsToDisplay) {
                        agentsToDisplay = agents.Agents.length;
                    }

                    $('#' + carouselId + ' .carousel-inner').html("");

                    if (agentsToDisplay === 1) {
                        $('.slides_prev-agentsnearyou .slides_next-agentsnearyou').hide();
                    }

                    for (var i = 0; i < agentsToDisplay; i++) {
                        var myHTML = "";
                        var agentLanguages = "";
                        var myAgencyName = agents.Agents[i].FullName;

                        if ((typeof myAgencyName === 'undefined') || (myAgencyName === '') || (myAgencyName === ' ')) {
                            myAgencyName = agents.Agents[i].CFAgencyName;
                        }
                        if (typeof myAgencyName === 'undefined') {
                            myAgencyName = "Not Available";
                        }

                        for (var j = 0; j < agents.Agents[i].Languages.length; j++) {
                            //if ((agents.Agents[i].Languages[j].toUpperCase() != "ENGLISH") && (agentLanguages + ", " + agents.Agents[i].Languages[j]).length <= 34) {
                            if ((agents.Agents[i].Languages[j].toUpperCase() != "ENGLISH") && (j < agents.Agents[i].Languages.length)) {
                                if (agentLanguages != "") {
                                    agentLanguages = agentLanguages + ", " + agents.Agents[i].Languages[j];
                                }
                                else {
                                    agentLanguages = agents.Agents[i].Languages[j];
                                }
                            }
                        }

                        myHTML += "<div class='col-xs-12 carousel-item'>";
                        myHTML += "<div class='abc-prospect'>";
                        myHTML += "<div class='profile'>";
                        myHTML += "<a name='&lpos=bsAgentNearYou' href='" + agents.Agents[i].AgentWebsiteURL + "?intcid=" + bsAgentsNearYou.SCPageName + "|bsAgentNearYou|website' title='" + bsAgentsNearYou.visitAgentIconText + "' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;bsAgentsNearYou&#39;]);'><img src='" + agents.Agents[i].AgentPhotoURL + "' alt='" + myAgencyName + "'  class='agentPhotoImg' /></a>";
                        myHTML += "<div class='info'>";
                        myHTML += "<a name='&lpos=bsAgentNearYou' class='agentName' href='" + agents.Agents[i].AgentWebsiteURL + "?intcid=" + bsAgentsNearYou.SCPageName + "|bsAgentNearYou|website' title='" + bsAgentsNearYou.visitAgentIconText + "' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;bsAgentsNearYou&#39;]);'>" + myAgencyName + "</a><br>";
                        myHTML += "<a name='&lpos=bsAgentNearYou' href='" + agents.Agents[i].AgentWebsiteURL + "?intcid=" + bsAgentsNearYou.SCPageName + "|bsAgentsNearYou|5starRatings' class='bsanyAgentStars-" + agents.Agents[i].ProducerNumber + " anyAgentStars' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Reviews&#39;, &#39;bsAgentsNearYou&#39;]);' > </a>";
                        myHTML += "<span class='phone'><a name='&lpos=AgentNearYou' href='tel:" + agents.Agents[i].Telephone + "' title='" + bsAgentsNearYou.callAgentLinkText + "' class='agentPhone'>" + agents.Agents[i].Telephone + "</a></span>";

                        if (agentLanguages != "" && agentLanguages.length > 0) {
                            //myHTML += "<div><div class='languageTxt'><span class='language'>" + agentLanguages + " </span>";
                            //if (j >= 4) {
                            //    myHTML += " <a name='&lpos=bsAgentNearYou' class='agentPhone' href='" + agents.Agents[i].AgentWebsiteURL + "?intcid=" + bsAgentsNearYou.SCPageName + "|bsAgentNearYou|website' title='" + bsAgentsNearYou.visitAgentIconText + "' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;bsAgentsNearYou&#39;]);'>" + "(+)" + "</a>";
                            //}
                            //myHTML += "</div></div>";
                            if (agentLanguages.length > 35) {
                                myHTML += "<div><div class='languageTxt'><span class='language'>" + agentLanguages.substring(0, 34);
                                myHTML += "<a name='&lpos=bsAgentNearYou' class='agentPhone' href='" + agents.Agents[i].AgentWebsiteURL + "?intcid=" + bsAgentsNearYou.SCPageName + "|bsAgentNearYou|website' title='" + bsAgentsNearYou.visitAgentIconText + "' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;bsAgentsNearYou&#39;]);'>" + "(+)" + "</a></span>";
                            } else {
                                myHTML += "<div><div class='languageTxt'><span class='language'>" + agentLanguages + "</span>";
                            }
                            myHTML += "</div></div>";
                        }

                        myHTML += "</div>";
                        myHTML += "<ul class='list-unstyled contact'>";
                        myHTML += "<li class='map-marker'>";
                        myHTML += "<a name='&lpos=AgentNearYou' class='agentAddress' title='" + bsAgentsNearYou.getDirectionsLinkText + "' target='_blank' href='https://www.bing.com/mapspreview?rtp=~adr.address." + agents.Agents[i].Address.Line1.replace(" ", "%20") + "," + agents.Agents[i].Address.City.replace(" ", "%20") + "," + agents.Agents[i].Address.AddressState + "," + agents.Agents[i].Address.ZipCode + "&intcid=" + bsAgentsNearYou.SCPageName + "|AgentsNearYou|directions' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Directions&#39;, &#39;AgentsNearYou&#39;]);'>" + agents.Agents[i].Address.Line1 + "<br>" + agents.Agents[i].Address.City + ", " + agents.Agents[i].Address.AddressState + " " + agents.Agents[i].Address.ZipCode + "</a>";
                        myHTML += "</li>";
                        myHTML += "</ul>";
                        myHTML += "</div>";
                        myHTML += "<ul class='social list-unstyled'>";
                        myHTML += "<li><a name='&lpos=bsAgentNearYou' href='tel:" + agents.Agents[i].Telephone + "' title='" + bsAgentsNearYou.callAgentLinkText + "'><i class='fa fa-phone'></i></a></li>";
                        if (!(agents.Agents[i].AgentFacebookURL !== null && typeof agents.Agents[i].AgentFacebookURL !== 'undefined' && agents.Agents[i].AgentFacebookURL !== "") &&
                            !(agents.Agents[i].AgentTwitterURL !== null && typeof agents.Agents[i].AgentTwitterURL !== 'undefined' && agents.Agents[i].AgentTwitterURL !== "")) {
                            //no Facebook && no Twitter
                            myHTML += "<li><a name='&lpos=bsAgentNearYou'  onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Email&#39;, &#39;bsAgentsNearYou&#39;]);' href='mailto:" + agents.Agents[i].CFEmailAddress + "' title='" + bsAgentsNearYou.emailAgentIconText + "'><i class='fa fa-envelope'></i></a></li>";
                            myHTML += "<li><a name='&lpos=bsAgentNearYou'  onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;bsAgentsNearYou&#39;]);'  href='" + agents.Agents[i].AgentWebsiteURL + "?intcid=" + bsAgentsNearYou.SCPageName + "|bsAgentNearYou|website' title='" + bsAgentsNearYou.visitAgentIconText + "'><i class='fa fa-desktop'></i></a></li>";
                        } else if ((agents.Agents[i].AgentFacebookURL !== null && typeof agents.Agents[i].AgentFacebookURL !== 'undefined' && agents.Agents[i].AgentFacebookURL !== "") &&
                            (agents.Agents[i].AgentTwitterURL !== null && typeof agents.Agents[i].AgentTwitterURL !== 'undefined' && agents.Agents[i].AgentTwitterURL !== "")) {
                            //Facebook && Twitter
                            myHTML += "<li><a name='&lpos=bsAgentNearYou'  onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Email&#39;, &#39;bsAgentsNearYou&#39;]);' href='mailto:" + agents.Agents[i].CFEmailAddress + "' title='" + bsAgentsNearYou.emailAgentIconText + "'><i class='fa fa-envelope'></i></a></li>";
                            myHTML += "<li><a name='&lpos=bsAgentNearYou'  onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;bsAgentsNearYou&#39;]);'  href='" + agents.Agents[i].AgentWebsiteURL + "?intcid=" + bsAgentsNearYou.SCPageName + "|bsAgentNearYou|website' title='" + bsAgentsNearYou.visitAgentIconText + "'><i class='fa fa-desktop'></i></a></li>";
                            myHTML += "<li><a name='&lpos=bsAgentNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Facebook&#39;, &#39;bsAgentsNearYou&#39;]);'  href='" + agents.Agents[i].AgentFacebookURL + "' title='" + bsAgentsNearYou.agentFacebookText + "'><i class='fa fa-facebook'></i></a></li>";
                            myHTML += "<li><a class='twitter-icon' name='&lpos=bsAgentNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Twitter&#39;, &#39;bsAgentsNearYou&#39;]);'  href='" + agents.Agents[i].AgentTwitterURL + "' title='" + bsAgentsNearYou.agentTwitterText + "'><i class='fa fa-twitter'></i></a></li>";
                        } else if ((agents.Agents[i].AgentFacebookURL !== null && typeof agents.Agents[i].AgentFacebookURL !== 'undefined' && agents.Agents[i].AgentFacebookURL !== "") &&
                            !(agents.Agents[i].AgentTwitterURL !== null && typeof agents.Agents[i].AgentTwitterURL !== 'undefined' && agents.Agents[i].AgentTwitterURL !== "")) {
                            //Facebook && no Twitter
                            myHTML += "<li><a name='&lpos=bsAgentNearYou'  onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Email&#39;, &#39;bsAgentsNearYou&#39;]);' href='mailto:" + agents.Agents[i].CFEmailAddress + "' title='" + bsAgentsNearYou.emailAgentIconText + "'><i class='fa fa-envelope'></i></a></li>";
                            myHTML += "<li><a name='&lpos=bsAgentNearYou'  onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;bsAgentsNearYou&#39;]);'  href='" + agents.Agents[i].AgentWebsiteURL + "?intcid=" + bsAgentsNearYou.SCPageName + "|bsAgentNearYou|website' title='" + bsAgentsNearYou.visitAgentIconText + "'><i class='fa fa-desktop'></i></a></li>";
                            myHTML += "<li><a name='&lpos=bsAgentNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Facebook&#39;, &#39;bsAgentsNearYou&#39;]);'  href='" + agents.Agents[i].AgentFacebookURL + "' title='" + bsAgentsNearYou.agentFacebookText + "'><i class='fa fa-facebook'></i></a></li>";
                        } else if (!(agents.Agents[i].AgentFacebookURL !== null && typeof agents.Agents[i].AgentFacebookURL !== 'undefined' && agents.Agents[i].AgentFacebookURL !== "") &&
                            (agents.Agents[i].AgentTwitterURL !== null && typeof agents.Agents[i].AgentTwitterURL !== 'undefined' && agents.Agents[i].AgentTwitterURL !== "")) {
                            //Twitter && no Facebook
                            myHTML += "<li><a name='&lpos=bsAgentNearYou'  onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Email&#39;, &#39;bsAgentsNearYou&#39;]);' href='mailto:" + agents.Agents[i].CFEmailAddress + "' title='" + bsAgentsNearYou.emailAgentIconText + "'><i class='fa fa-envelope'></i></a></li>";
                            myHTML += "<li><a name='&lpos=bsAgentNearYou'  onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;bsAgentsNearYou&#39;]);'  href='" + agents.Agents[i].AgentWebsiteURL + "?intcid=" + bsAgentsNearYou.SCPageName + "|bsAgentNearYou|website' title='" + bsAgentsNearYou.visitAgentIconText + "'><i class='fa fa-desktop'></i></a></li>";
                            myHTML += "<li><a class='twitter-icon' name='&lpos=bsAgentNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Twitter&#39;, &#39;bsAgentsNearYou&#39;]);'  href='" + agents.Agents[i].AgentTwitterURL + "' title='" + bsAgentsNearYou.agentTwitterText + "'><i class='fa fa-twitter'></i></a></li>";
                        }
                        myHTML += "</ul>";
                        myHTML += "</div>";
                        myHTML += "</div>";

                        $('#' + carouselId + ' .carousel-inner').append(myHTML);

                        if ($('.reviews-' + agents.Agents[i].ProducerNumber).length === 0) {
                            globalEvents.Event('agentReviewRetrieved').subscribe(function (agentNumber) { bsAgentsNearYou.getReviewDiv(agentNumber, reviewText, reviewEnding); });
                            bsCommon.retrieveAgentReview(agents.Agents[i].ProducerNumber);
                        }
                        else {
                            bsAgentsNearYou.getReviewDiv(agents.Agents[i].ProducerNumber, reviewText, reviewEnding);
                        }
                    }

                    bsAgentsNearYou.setUpPagination(carouselId, panelsToDisplay, isCustomer);
                    setTimeout(function () { bsAgentsNearYou.checkAgentImages(carouselId) }, 1000);

                    $('#' + carouselId + ' .carousel-inner').addClass('loaded');
                } else {
                    bsAgentsNearYou.clearAgentList(carouselId);
                }
            }
            catch (e) {
                bsCommon.clearAgents();
            }
        }
        else {
            bsAgentsNearYou.clearAgentList(carouselId);
        }
    },

    checkAgentImages: function (carouselId) {
        try {
            for (var i = 0; i < $('#' + carouselId).find('img.agentPhotoImg').length; i++) {
                if (!bsCommon.isImageOk($('#' + carouselId).find('img.agentPhotoImg')[i])) {
                    $($('#' + carouselId).find('img.agentPhotoImg')[i]).attr('src', '/resources/images/agent-mia.jpg');
                }
            }
        }
        catch (err) {
        }
    },

    setUpPagination: function (carouselId, panelsToDisplay, isCustomer) {
        if ($('#' + carouselId + ' .slick-initialized').length == 0) {
            if (isCustomer) {
                $('#' + carouselId + ' .carousel-inner').slick({
                    appendDots: $('#' + carouselId + ' .carousel-indicators'),
                    autoplay: false,
                    autoplaySpeed: 2500,
                    dots: true,
                    infinite: true,
                    nextArrow: $('#' + carouselId + ' .right.carousel-control'),
                    prevArrow: $('#' + carouselId + ' .left.carousel-control'),
                    slidesToScroll: panelsToDisplay,
                    slidesToShow: panelsToDisplay,
                    speed: 500,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToScroll: 1,
                                slidesToShow: 1
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToScroll: 2,
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToScroll: 1,
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            }
            else {
                $('#' + carouselId + ' .carousel-inner').slick({
                    appendDots: $('#' + carouselId + ' .carousel-indicators'),
                    autoplay: false,
                    autoplaySpeed: 2500,
                    dots: true,
                    infinite: true,
                    nextArrow: $('#' + carouselId + ' .right.carousel-control'),
                    prevArrow: $('#' + carouselId + ' .left.carousel-control'),
                    slidesToScroll: panelsToDisplay,
                    slidesToShow: panelsToDisplay,
                    speed: 500,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToScroll: 2,
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToScroll: 1,
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            }
        }
        //if ((navigator.userAgent.indexOf('Safari') != -1) && (navigator.userAgent.indexOf('Chrome') == -1))
        //{
        //    if ( $('#' + carouselId + ' .carousel-inner').length > 1 ) {
        //        $('.carousel-control').css('display', '-webkit-inline-box');
        //    }
        //}
    },

    getReviewDiv: function (agentNumber, reviewText, reviewEnding) {
        if ($('.reviews-' + agentNumber).length !== 0) {
            $('.bsanyAgentStars-' + agentNumber).empty();
            $('.bsanyAgentStars-' + agentNumber).append($('.reviews-' + agentNumber).clone().wrap('<div>').parent().html());

            if (($('.bsanyAgentStars-' + agentNumber + ' .reviews-' + agentNumber + ' .count').length > 0) && ($('.bsanyAgentStars-' + agentNumber + ' .reviews-' + agentNumber + ' .count')[0].innerHTML !== "1")) {
                reviewText += reviewEnding;
            }

            $('.bsanyAgentStars-' + agentNumber + ' .reviews-' + agentNumber + ' .reviewText').html(reviewText);
        }
    }
};

/***** End bsAgentsNearYou Scripts *****/
